module.exports = __webpack_public_path__ + "static/media/51_B.a43a6a1a.png";